import { useSelector } from 'react-redux'
import { find } from 'lodash'

import { areSameValue } from '../../core/utils'

const useBrandCurationTaskSelector = taskId => {
  const brandCurationTask = useSelector(store =>
    find(store.brandCurationTasks.brandCurationTasks?.data?.result, ({ id }) =>
      areSameValue(id, taskId),
    ),
  )
  return brandCurationTask || {}
}

export default useBrandCurationTaskSelector
